import Vue from 'vue'

export default {
    UPDATE_FUNNIES (state, value) {
        Vue.set(state, 'funnies', value);
    },
  SET_FUNNIES (state, value) {
        this.commit('UPDATE_FUNNIES', value);
    },
    SET_SELECTED_FUNNY (state,  value ) {
      Vue.set(state, 'selectedFunny', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/funnies/mutations.js